import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  mediaLibraryParams,
  MediaLibraryPage,
  mediaListQueryOptions,
  mediaListSearchSchema,
} from '@/features/media';

export const Route = createFileRoute('/_authed/_active/org/media')({
  validateSearch: mediaListSearchSchema,
  loaderDeps: ({ search }) => search,
  staticData: { crumb: 'common:nav.media', tours: ['media.library'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  loader: ({ context, deps }) =>
    context.queryClient
      .infiniteQuery({
        ...mediaListQueryOptions(mediaLibraryParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined),
  component: MediaLibraryPage,
});
